<template>
  <div class="content">
    <div>
      <div class="select-container xrow ai-c" v-if="!userInfo.location.city">
        <div class="title">市区选择：</div>
        <div>
          <el-select v-model="selectCity" placeholder="请选择">
            <el-option v-for="item in list" :key="item.key" :label="item.city" :value="item.key" onchange="selectCity`">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="xrow device-container ai-c flex-no-wrap"
        :style="{ 'left': !userInfo.location.city ? '330px' : '10px' }">
        <div class="flex1 no-wrap" @click="changeHigh">
          <img src="../assets/设备1.png" alt="">
          <span>高标准</span>
        </div>
        <div class="flex1 pdl20 pdr20 no-wrap" @click="changeN9500">
          <img src="../assets/设备2.png" alt="">
          <span>N9500</span>
        </div>
        <div class="flex1 no-wrap" @click="changeNs400">
          <img src="../assets/设备3.png" alt="">
          <span>NS400</span>
        </div>
        <div class="flex1 no-wrap device-item">
          <span>当前设备总数：{{ deviceLength }}</span>
        </div>
      </div>
      <div id="mapContainer" element-loading-background="rgba(0, 0, 0, 1)" class="mapContainer"></div>

    </div>

  </div>
</template>
  
<script>
import { get } from "@/utils/http";
import { find, forEach, concat } from "lodash";
import { tiandiDeviceMapImg, jiangsuprovinceList, deviceTypeList } from "@/utils/config.js"
export default {
  name: "newMap",
  data() {
    return {
      mapchart: null,
      map_opt: jiangsuprovinceList,
      infoWindow: null,
      province: "",
      zoom: 0,
      center: [0, 0],
      selectCity: 15,
      showN9500: true,
      showNS400: true,
      showHigh: true,
      n9500Markers: [],
      ns400Markers: [],
      highMarkers: [],
      deviceLength: 0,
      userInfo: JSON.parse(localStorage.getItem("userInfo"))
    };
  },
  watch: {
    selectCity(v, v2) {
      if (v) {
        const o = find(this.list, { key: v })
        this.mapchart.setCenter(o.center)
        this.mapchart.setZoom(o.zoom)
      }
      //  console.log("sds", v, '--', v2)
    }
  },
  computed: {
    list() {
      const temp = concat([{ key: 15, city: "全省", zoom: 8, center: [119.365478, 33.114797] }], jiangsuprovinceList)
      return temp;
    },
  },
  mounted() {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    if (userInfo.location.city) {
      this.province = userInfo.location.city;
      forEach(jiangsuprovinceList, item => {
        if (userInfo.location.city.indexOf(item.city) !== -1) {
          this.map_opt = item.childList;
          this.zoom = this.$store.state.mapZoomSize ? this.$store.state.mapZoomSize : item.zoom;
          this.center = this.$store.state.mapCenter.length > 0 ? this.$store.state.mapCenter : item.center
        }
      });
    } else {
      this.province = userInfo.location.province;
      this.map_opt = jiangsuprovinceList;
      this.zoom = this.$store.state.mapZoomSize ? this.$store.state.mapZoomSize : 8;
      this.center = this.$store.state.mapCenter.length > 0 ? this.$store.state.mapCenter : [119.365478, 33.114797];
    }
    this.initAreaMap();
  },
  methods: {

    // 初始化地图
    initAreaMap() {
      /////////////////
      var _that = this;

      var opts = { subdistrict: 0, extensions: 'all', level: 'province' };
      //利用行政区查询获取边界构建mask路径
      //也可以直接通过经纬度构建mask路径
      var district = new AMap.DistrictSearch(opts);
      console.log("district", district)
      district.search(_that.province, function (status, result) {
        console.log("status", status)
        console.log("result", result)
        var bounds = result.districtList[0].boundaries;
        var mask = [];

        for (var i = 0; i < bounds.length; i += 1) {
          mask.push([bounds[i]])
        }
        const map = new AMap.Map("mapContainer", {
          mask: mask,
          showLabel: false,//不显示地图文字标记
          viewMode: "3D",
          pitch: 0,
          // rotation: -35,// 这个属性会让地图倾斜
          layers: [
            // 高德默认标准图层
            new AMap.TileLayer.Satellite({ zIndex: 10 }), // 地图不带线路的写法是添加：zIndex:10
            new AMap.TileLayer.RoadNet(),
            // 楼块图层
            new AMap.Buildings({
              zooms: [16, 18],
              zIndex: 10,
              heightFactor: 5, //2倍于默认高度，3D下有效
            }),
          ],
          // mapStyle: "amap://styles/f5183f7e15222893686bfcd9ee61f3b3", //设置地图的显示样式
          mapStyle: "amap://styles/light",
          resizeEnable: true,
          rotateEnable: true,
          pitchEnable: true,
          zoom: _that.zoom,
          buildingAnimation: true, //楼块出现是否带动画
          expandZoomRange: true,
          zooms: [3, 30],
          center: _that.center,
          //  center: [118.890232, 31.953877],
        });
        // map.on("click", function (e) {
        //   console.log('----', map.getCenter());
        //   console.log('---cccc-', map.getZoom());
        // })
        _that.mapchart = map;
        //添加描边
        for (var i = 0; i < bounds.length; i += 1) {
          const list = new AMap.Polyline({
            path: bounds[i], strokeColor: '#3078AC',
            strokeWeight: 10,
            map: map
          })
        }
        // this.mapchart=map;
        for (let i = 0; i < _that.map_opt.length; i++) {

          district.search(_that.map_opt[i].city, (status, result) => {
            // console.log(" _that.map_optresultresultresult==", result)
            //  console.log("dddd", _that.map_opt[i])
            _that.handlePolygon(result, "red", map, _that.map_opt[i].city, _that.map_opt[i].citycode);


          });
        }
        _that.handleMarker()
      });
    },
    handlePolygon(result, color, map, name, citycode) {

      if (result && result.districtList) {
        //   console.log('result==', result)
        let bounds = result.districtList[0].boundaries;

        if (bounds) {
          for (let i = 0, l = bounds.length; i < l; i++) {
            //生成行政区划polygon
            let polygon = new AMap.Polygon({
              map: map, // 指定地图对象
              strokeWeight: 2, // 轮廓线宽度
              path: bounds[i], //轮廓线的节点坐标数组
              fillOpacity: 0, //透明度
              // fillColor: color, //填充颜色
              strokeColor: "yellow", //线条颜色
            });
            // polygon.on('click', (e) => {
            // 点击绘制的区域时执行其他交互
            //
            // })
          }
          // 地图自适应


          // 创建纯文本标记
          var bounds_center = result.districtList[0].center;


          var text = new AMap.Text({
            text: name,
            anchor: 'center', // 设置文本标记锚点
            draggable: false,
            cursor: 'dafault',
            angle: 0,
            style: {
              'padding': '2px 10px',
              'background': 'repeating-linear-gradient(to right,transparent,#000000d9,transparent)',
              'border-width': 1,
              'font-size': '12px',
              'color': 'rgba(255,255,255,1)',
              'border-left-width': 0,
              'border-right-width': 0,
              'border-radius': 0,
              'border-image': 'linear-gradient(to right, #ffffff26, white, #ffffff26) 1'
            },
            position: bounds_center
          });
          text.setMap(map);
        }

      }
    },

    handleMarker() {

      get('/device/list').then(res => {
        if (res.data) {
          this.deviceLength = res.data.length
          this.$store.commit("setDeviceCount", res.data.length);
          let mark95List = [];
          let mark40List = [];
          let markhighList = [];
          for (const item of res.data) {

            if (item.location.longitude && item.location.latitude) {


              var img = "";
              if (!item.online) {
                img = require("../assets/设备5.png");
              } else {
                const o = find(tiandiDeviceMapImg, { deviceType: item.model });
                img = o ? o.img : require("../assets/设备4.png");
              }


              var markerContent = `<div class="custom-content-marker xrow ai-c" id=${item.key} >` +
                `   <div><img src=${img} style="width:30px;height:30px;"></div>` +
                `   <div class="map-cell-name">${item.name}</div>` +
                `</div>`;

              let content = "";
              if (this.userInfo.roles.indexOf("诺丽技术员") !== -1) {
                //技术员
                content = `<div class="map-tip-container">` +
                  `<div class="xrow jc-sb">名称：<div></div><div>${item.name}</div></div>` +
                  `<div class="xrow jc-sb">编号：<div></div><div>${item.keyLegacy}</div></div>` +
                  `<div class="xrow jc-sb">状态：<div></div><div>${item.status}</div></div>` +
                  `<div class="xrow jc-sb">维保期：<div></div><div>${item.maintainUntil}</div></div>` +

                  `<div class="xrow jc-sb">地址：<div></div><div>${item.location.province}${item.location.city}${item.location.district}${item.location.town ?? ""}</div></div>` +

                  `</div>`

              } else {
                content = `<div class="map-tip-container">` +
                  `<div class="xrow jc-sb">名称：<div></div><div>${item.name}</div></div>` +
                  // `<div class="xrow jc-sb">编号：<div></div><div>${item.key}</div></div>` +
                  // `<div class="xrow jc-sb">模式：<div></div><div>${item.model}</div></div>` +
                  `<div class="xrow jc-sb">状态：<div></div><div>${item.status}</div></div>` +
                  `<div class="xrow jc-sb">地址：<div></div><div>${item.location.province}${item.location.city}${item.location.district}${item.location.town ?? ""}</div></div>` +

                  `</div>`

              }

              var marker = new AMap.Marker({
                position: new AMap.LngLat(item.location.longitude, item.location.latitude),
                // 将 html 传给 content
                content: markerContent,
                // tipContent: content,
                // item: item
                // 以 icon 的 [center bottom] 为原点
                //  offset: new AMap.Pixel(-13, -30)
              });

              // 将 markers 添加到地图

              if (item.model === "N9500") {
                mark95List.push(marker)
              } else if (item.model === "NS400") {
                mark40List.push(marker)
              } else {
                markhighList.push(marker)
              }

              this.mapchart.add(marker);



              // var infoWindow = new AMap.InfoWindow({
              //   isCustom: true,  //使用自定义窗体
              //   content: content,
              //   offset: new AMap.Pixel(0, -20)
              // });
              var _that = this;
              // marker.on('mouseover', _that.markerClick);
              marker.on('mouseover', function (e) {
                _that.markerClick(e, content, item)
                //   infoWindow.open(_that.mapchart, new AMap.LngLat(item.location.longitude, item.location.latitude));
              });

              marker.on('mouseout', function () {
                _that.mapchart.clearInfoWindow();
              });
              marker.on('click', function (e) {
                var zoom = _that.mapchart.getZoom();
                var center = _that.mapchart.getCenter();
                _that.$store.commit("setMapCenter", [center.R, center.Q])
                _that.$store.commit("setMapZoomSize", zoom)
                _that.$store.commit("setCurrentItem", JSON.stringify(item))
                const key = item.key;
                _that.$store.commit("setDeviceKey", key)
                localStorage.setItem("deviceKey", key);
                localStorage.setItem("activeName", 'soil');
                _that.getMenuList(key)
                // _that.$router.push({
                //   path: `/encoder/soil/${key}`,
                //   // query: { id:marker.key },
                // });
              });

            }
          }
          this.n9500Markers = mark95List;
          this.ns400Markers = mark40List;
          this.highMarkers = markhighList;
          //  this.mapchart.setFitView();
        }
      })


    },
    markerClick(e, content, item) {
      var _that = this;
      var infoWindow = new AMap.InfoWindow({
        offset: new AMap.Pixel(5, -30),
        content: content,
      });
      // infoWindow.setContent(e.target.content);
      infoWindow.open(_that.mapchart, new AMap.LngLat(item.location.longitude, item.location.latitude));
    },
    changeN9500() {
      var _that = this;
      if (_that.showN9500) {
        _that.showN9500 = false;
        _that.mapchart.remove(_that.n9500Markers)
      } else {
        _that.showN9500 = true;
        _that.mapchart.add(_that.n9500Markers)
      }
    },
    changeNs400() {
      var _that = this;
      if (_that.showNS400) {
        _that.showNS400 = false;
        _that.mapchart.remove(_that.ns400Markers)
      } else {
        _that.showNS400 = true;
        _that.mapchart.add(_that.ns400Markers)
      }
    },
    changeHigh() {
      var _that = this;
      if (_that.showHigh) {
        _that.showHigh = false;
        _that.mapchart.remove(_that.highMarkers)
      } else {
        _that.showHigh = true;
        _that.mapchart.add(_that.highMarkers)
      }
    },
    getMenuList(key) {
      var _that = this;
      get(`/device?key=${key}`, { key: key }).then(res => {
        if (res.data && res.data.components) {
          const components = res.data.components;
          let temp = [];
          forEach(deviceTypeList, item => {
            if (components.indexOf(item.code) !== -1) {
              temp.push(item)
            }
          });

          _that.$store.commit("setSilderComponent", components);
          _that.$router.push({
            path: `${temp[0].path}${key}`,
            // query: { id:marker.key },
          });
        }

      }).catch(error => {
        console.log("error", error)
      })
    }
  },

};
</script>
  
<style lang="less" scoped>
.content {
  position: relative;
  left: 10px;
  top: 0;
  width: calc(100vw - 175px);
  height: calc(100vh - 90px);
  overflow-y: auto;
  overflow-x: hidden;
}

.mapContainer {
  width: 500px;
  height: 500px;
  width: calc(100vw - 175px);
  height: calc(100vh - 90px);
}

.select-container {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 3;
  background: white;
  /* width: 261px; */
  height: 62px;
  padding: 0 10px;
  box-shadow: 2px 2px 10px #e6e6ef;
  border-radius: 10px;

  .title {
    font-size: 14px;
  }
}

.device-container {
  position: absolute;
  top: 10px;
  left: 330px;
  z-index: 3;
  background: white;
  /* width: 261px; */
  height: 62px;
  padding: 0 10px;
  box-shadow: 2px 2px 10px #e6e6ef;
  border-radius: 10px;

  .no-wrap {
    white-space: nowrap;
    cursor: pointer;
  }
}

.device-item {
  font-size: 16px;
  margin-left: 20px;
  font-weight: bold;
  cursor: default;
}
</style>
  